import axios from 'axios'

export default{
    install(Vue){
        // 동기 통신을 위한 axios 함수
        Vue.prototype.$syncApiCallPost = function (putObj, url, callback, out_flag){
            return new Promise((resolve, reject) => { 
                let obj = {
                    "header": {
                        "baRq": "IN_PARAM,SESSION",
                        //"baRs": "OUT_PARAM"
                        "baRs": out_flag
                    },
                    "body": {
                        "IN_PARAM": [putObj],
                        "SESSION":[]
                    }
                }
                axios.post(url , obj)
                .then((response) => {
                    /*console.log(response)
                    console.log('a = ' + JSON.stringify(response))
                    console.log('a = ' + response.status)
                    console.log('a = ' + response.data)
                    console.log('a = ' + JSON.stringify(response.data.header))
                    console.log('a = ' + JSON.stringify(response.data.body))*/
                    //callback(response)
                    if (out_flag === '') {
                        callback()
                    } else {
                        callback(response.data)
                    }
                
                    resolve(response)
                })
                .catch((err) => {
                    alert(err.message)
                    // 여기서 에러코드 걸러낼것
                    reject(err)
                })
            })
        },
        // 비동기 통신을 위한 axios 함수
        Vue.prototype.$asyncApiCallPost = function (putObj, url, callback, out_flag){
            let obj = {
                "header": {
                    "baRq": "IN_PARAM,SESSION",
                    "baRs": out_flag
                },
                "body": {
                    "IN_PARAM": [putObj],
                    "SESSION":[]
                }
            }
            axios.post(url , obj)
            .then((response) => {
                if (out_flag === '') {
                    callback()
                } else {
                    callback(response.data)
                }
            })
            .catch((err) => {
                alert(err.message)
                // 여기서 에러코드 걸러낼것
            })
        },
        // 나중에 공통함수로 뽑아서 사용
        Vue.prototype.$elementNameByIndex = function (array, search) {
            return array.findIndex(x => x.name === search)
        },
        Vue.prototype.$elementFieldByIndex = function (array, feild ,search) {
            return array.findIndex(x => x[feild] === search)
        },
        // this.$loading.show({delay:0})
        Vue.prototype.$loadingHide = function () {
            this.$loading.hide()
        },
        Vue.prototype.$getOzViewData= function (fileName, paramArray){
            let object = {}
            object.fileName = fileName
            object.params = []
      
            for (let i=0; i<paramArray.length; i++) {
              let tmp = {}
              for(let obj in paramArray[i]){
                // console.log('obj : ' + i + ' = ' + paramArray[i][obj])
                // console.log('obj : ' + i + ' = ' + obj)
                tmp[obj] = paramArray[i][obj].toString()
                // tmp[obj] = paramArray[i][obj]
              }
              object.params.push(tmp)
            }
      
            return object
        },
        Vue.prototype.$getInitPassword = function (){
            var numStr = '123456790'
            var upperStr = 'QWERTYUIOPASDFGHJKLZXCVBNM'
            var lowerStr = 'qwertyuiopasdfghjklzxcvbnm'
            var specialStr = '!@#$%^*+=-*'

            var wordArray = [numStr, upperStr, lowerStr, specialStr]

            var listArray = [0,0,1,1,2,2,3,3]


            for (var i = 0; i<listArray.length; i++) {

                var securityArray = new Uint32Array(1)
                crypto.getRandomValues(securityArray)
                var securityRandom = securityArray[0] / (0xffffffff + 1)
                var randomNumber = Math.floor(securityRandom * 100) + 1

                var ran = parseInt(randomNumber * listArray.length)
                // console.log('ran = ' + ran)
                var tmp = listArray[i]
                listArray[i] = listArray[ran]
                listArray[ran] = tmp
            }

            var result = ''

            for (var idx = 0; idx<listArray.length; idx++) {
                var num = listArray[idx]
                var str = wordArray[num] 
                var securityStr = new Uint32Array(1)
                crypto.getRandomValues(securityStr)
                var securityStrRandom = securityStr[0] / (0xffffffff + 1)
                var wordRan = Math.floor(securityStrRandom * str.length)
                result += str.charAt(wordRan)
            } 

            return result
        },
        Vue.prototype.$replaceAll = function(str, searchStr, replaceStr) {
            return str.split(searchStr).join(replaceStr)
        }
         
    }
}